const columns = ['id', 'slug', 'name', 'groups', 'actions']
export const [COLUMN_ID, COLUMN_SLUG, COLUMN_NAME, COLUMN_GROUPS, COLUMN_ACTIONS] = columns

export const gridColumns = [
  {
    key: COLUMN_ID,
    size: 1,
    minWidth: 100,
  },
  {
    key: COLUMN_NAME,
    size: 2,
    minWidth: 200,
  },
  {
    key: COLUMN_GROUPS,
    size: 2,
    minWidth: 200,
  },
  {
    key: COLUMN_ACTIONS,
    size: 2,
    minWidth: 200,
  },
]
